import {ReactNode, useContext} from "react";
import {FormContext} from "@/components/form/Form.tsx";

export default function FormActions({children}: {children: (actions: FormActionRenderProps) => ReactNode}) {
    const form = useContext(FormContext);
    return (
        <>
            {children({
                submit: form.submit,
                form: form
            })}
        </>
    )

}